import { render, staticRenderFns } from "./ContentDiscovery.vue?vue&type=template&id=417f8e2c&"
import script from "./ContentDiscovery.vue?vue&type=script&lang=js&"
export * from "./ContentDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports